import { Box } from '@coolblue-development/freddy';
import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';
export const BannerImageContainer = styled(Box, {
    shouldForwardProp: prop => isPropValid(prop),
}) `
  position: relative;
  border: ${({ theme, hideBorder }) => !hideBorder ? `0.1rem solid ${theme.color.border.base}` : 'none'};
  border-radius: ${({ theme }) => theme.spacing[100]};
  overflow: hidden;
  aspect-ratio: ${({ aspectRatio }) => (aspectRatio ? aspectRatio : 'auto')};

  img {
    width: 100%;
    height: auto;
  }
`;
//# sourceMappingURL=Banners.styled.js.map